import { RenderElementProps } from 'slate-react';

export const ELEMENT_IMAGE_SLIDE_SHOW = 'image-slide-show';

export interface ImageSlideShowPluginOptions {
  isReadOnly?: boolean;
  title?: string;
}
export interface ImageSlideShowPluginElementProps
  extends RenderElementProps,
    ImageSlideShowPluginOptions {}
